<template>
  <el-dialog
    :visible="visible"
    :show-close="hasSelectedOffice"
    custom-class="select-office-dialog"
    title="Before You Get Started, Select an Office"
  >
    <div v-if="locationSearch.selectedOffice">
      <el-alert
        type="info"
        v-if="(locationSearch.selectedOffice == suggestedOffice)"
        title="This suggestion is because you've interacted with this office before."
      />
      <SelectOfficeCard :office="locationSearch.selectedOffice" selected @unselect="onUnselectOffice" />
      <el-row type="flex" align="middle" justify="center">
        <el-button v-loading="savingOfficeSelection" class="mt-3" type="primary" round @click="onConfirmLocationSelection">Confirm Selection</el-button>
      </el-row>
    </div>
    <div v-else>
      <p class="ma-0">Select an M &amp; M Tax Service location closest to you or one you've done business with in the past. A preparer from your selected location will handle your request. You can also select the Virtual Office.</p>
      <h3>Search Offices by Zipcode</h3>
      <el-alert
          v-show="locationSearch.errorMessage"
          :title="locationSearch.errorMessage"
          :closable="false"
          show-icon
          type="error"
        />
      <el-form :model="locationSearch.form" :rules="locationSearch.rules" ref="locationSearch" class="zipcode-search" @submit.native.prevent>
        <el-form-item class="zipcode-form-item" label="Zipcode" prop="zipcode" required>
          <el-input v-model="locationSearch.form.zipcode" v-mask="'#####'" placeholder="Zipcode" @keyup.enter.native="onSearch">
            <el-button v-loading="locationSearch.searching" class="input-button" slot="append" @click="onSearch">Search</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <p v-show="locationSearch.results.length === 0 && locationSearch.showEmptyState" class="search-empty-state">Search by zipcode to find an office near you</p>
      <p v-show="locationSearch.results.length === 0 && !locationSearch.showEmptyState" class="search-empty-state no-results-found">
        No offices found near you.
        <el-link @click="onSelectOffice($options.Office.VIRTUAL_OFFICE)">Select the Virtual Office</el-link>
      </p>
      <SelectOfficeCard v-for="office in locationSearch.results" :key="office.id" :office="office" @select="onSelectOffice" />
      <h3>File Your Tax Return Remotely</h3>
      <SelectOfficeCard :office="$options.Office.VIRTUAL_OFFICE" @select="onSelectOffice" />
    </div>
  </el-dialog>
</template>

<script>
import api from '@/api';
import Client from '@/model/Client';
import Office from '@/model/Office';

import SelectOfficeCard from '@/component/SelectOfficeCard.vue';

export default {
  Office,
  components: {
    SelectOfficeCard,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    hasSelectedOffice: {
      typoe: Boolean,
      default: false,
    },
    suggestedOffice: {
      type: Object,
      default: () => undefined,
    },
  },
  data() {
    return {
      savingOfficeSelection: false,
      locationSearch: {
        searching: false,
        showEmptyState: true,
        errorMessage: undefined,
        form: {
          zipcode: '',
        },
        rules: {
          zipcode: [{
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('Zipcode is required.'));
              } else if (!value.match(/^[0-9]{5}$/i)) {
                callback(new Error('Please enter a valid 5-digit zip code'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          }],
        },
        results: [],
        selectedOffice: undefined,
      },
    };
  },
  methods: {
    async onSearch() {
      try {
        await this.$refs.locationSearch.validate();
      } catch (e) {
        return;
      }

      try {
        this.locationSearch.searching = true;
        this.locationSearch.errorMessage = undefined;
        const response = await api.docutax.findNearbyLocations(this.locationSearch.form.zipcode);
        this.locationSearch.results = response.data.map(office => new Office(office));
        this.locationSearch.showEmptyState = false;
      } catch (e) {
        this.locationSearch.errorMessage = 'An error occurred while searching by the provided zipcode';
        console.error(e);
      } finally {
        this.locationSearch.searching = false;
      }
    },
    async onConfirmLocationSelection() {
      try {
        this.savingOfficeSelection = true;
        const response = await api.docutax.selectOffice(this.locationSearch.selectedOffice);
        if (response.data) {
          this.$emit('client-updated', new Client(response.data));
        }
      } catch (e) {
        console.error('failed to select office', this.locationSearch.selectedOffice, e);
        this.$message.error('Failed to apply office selection, please try again');
      } finally {
        this.savingOfficeSelection = false;
      }
    },
    onSelectOffice(office) {
      this.locationSearch.selectedOffice = office;
    },
    onUnselectOffice() {
      this.locationSearch.selectedOffice = undefined;
      this.suggestedOffice.data = undefined;
    },

  },
};
</script>
